import HistoricalData from './HistoricalData.vue';
const SaveHistoricalData = {
    install(Vue) {
        Vue.component('HistoricalData', HistoricalData);
    }
}
export default SaveHistoricalData